import { render, staticRenderFns } from "./LessonWatch.vue?vue&type=template&id=27344cae"
import script from "./LessonWatch.vue?vue&type=script&lang=js"
export * from "./LessonWatch.vue?vue&type=script&lang=js"
import style0 from "./LessonWatch.vue?vue&type=style&index=0&id=27344cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports